/* eslint-disable import/no-cycle */
import React, { } from 'react';
import Header from '../components/Header';
import Navbar from '../components/Navbar1';

import './Zackat.css';

const NotFound = () => (
  <div className="m-2 md:m-10 mt-24 p-2 md:p-10 bg-white rounded-3xl zackat-div">
    <div className="nav-bar-bg">
      <Navbar />
    </div>
    <Header category="" title="404 - Not Found" />
    <div style={{ display: 'flex', justifyContent: 'center' }}>
      <h2>Sorry, the page you are looking for could not be found.</h2>
    </div>
  </div>
);
export default NotFound;
